import { render } from "./CrateLabel.vue?vue&type=template&id=80dfbdbc"
import script from "./CrateLabel.vue?vue&type=script&lang=js"
export * from "./CrateLabel.vue?vue&type=script&lang=js"

import "./CrateLabel.vue?vue&type=style&index=0&id=80dfbdbc&lang=css"

import exportComponent from "/var/www/html/projects/hetfruit/resources/vueapps/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__